import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useFetch } from "../../../hooks/useFecth";
import HandlerApp from "../../../utils/handlerApp";


const LocationsView = ()=>{
    const endpoint = "administration/locations";
    const [t,i18n] = useTranslation("global");
    const api = useFetch();
    const handlerApp = HandlerApp();
    const [location,setLocation] = useState({});
    const [title,setTitle] = useState("");
    const nav = useNavigate();

    const {id} = useParams();
    useEffect(()=>{
        handlerApp.setLoader(true);
        api.get(endpoint+"/"+id)
        .then(response =>{
            if(response.success){
                handlerApp.setLoader(false);
                let data = response.data[0];
                setTitle(data.location_name);
                setLocation(data);
            }else{
                handlerApp.handlerResponse(response);
                handlerApp.setLoader(false);
            }
        })
        .catch(error=>{
            handlerApp.showError(t(error.message));
            handlerApp.setLoader(false);
        })
    },[])

    const back = ()=>{
        nav(-1);
    }

    return(
        <div className="app">
            <div className="container bold-container-content">
                <span className="material-symbols-outlined absolute" role="button" onClick={back}>arrow_back</span>
                <div className="title-section-forms">
                    {title}
                </div>
                <div className="row">
                    <div className="col-md-6 mb-2">
                        <dt>{t('locationComponent.location')}:</dt>
                        <dd>{location.location_name}</dd>
                    </div>
                    <div className="col-md-6 mb-2">
                        <dt>{t('country')}</dt>
                        <dd>{location.country_name}</dd>
                    </div>
                    <div className="col-md-6 mb-2">
                        <dt>{t('state')}</dt>
                        <dd>{location.state_name}</dd>
                    </div>
                    <div className="col-md-6 mb-2">
                        <dt>{t('city')}</dt>
                        <dd>{location.city_name}</dd>
                    </div>
                    <div className="col-md-6 mb-2">
                        <dt>{t('address')}</dt>
                        <dd>{location.location_address}</dd>
                    </div>
                    <div className="col-md-6 mb-2">
                        <dt>{t('zipCode')}</dt>
                        <dd>{location.location_zipcode}</dd>
                    </div>
                </div>
                <div className="footer-section-view row">
                    <span className="divisor"></span>
                    <div className="col-md-6">
                        <span className="text-gray light small-text">{t('createdBy')}: {location.created_by}</span>
                    </div>
                    <div className="col-md-6">
                        <span className="text-gray light small-text">{t('createdAt')}: {handlerApp.getDate(location.location_created_at)}</span>
                    </div>
                    <div className="col-md-6">
                        {location.location_modified_by !== null && <span className="text-gray light small-text">{t('modifiedBy')}: {location.modified_by}</span>}
                    </div>
                    <div className="col-md-6">
                        {location.location_modified_at !== null && <span className="text-gray light small-text">{t('modifiedAt')}: {handlerApp.getDate(location.location_modified_at)}</span>}
                    </div>
                </div>
            </div>
        </div>
        
    );
}

export default LocationsView;